import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { loginRequest } from "./authConfig.js";
import { useUserContext } from "../Contexts/UserProvider.tsx";

export const useAuthentication = () => {
  const { instance, inProgress, accounts } = useMsal();
  const { resetUserContext } = useUserContext();

  const profileEdit = () => {
    if (inProgress !== InteractionStatus.None) {
      console.warn("Auth interaction in progress, skipping profileEdit");
      return;
    }
    return instance.loginRedirect(loginRequest);
  };

  const logout = () => {
    if (inProgress !== InteractionStatus.None) {
      console.warn("Auth interaction in progress, skipping logout");
      return;
    }

    const account = instance.getActiveAccount() || accounts[0] || undefined;

    // Drop in-memory + persisted app session before MSAL redirect so the next
    // login cannot hydrate the previous account's tenant / profile / headers.
    resetUserContext();
    sessionStorage.clear();

    return instance.logoutRedirect({
      account,
      postLogoutRedirectUri:
        process.env.REACT_APP_POST_REDIRECT_URL || "/elystrion-login",
    });
  };

  const redirectLogin = () => {
    if (inProgress !== InteractionStatus.None) {
      return;
    }
    if (instance.getAllAccounts().length > 0) {
      return;
    }
    return instance.loginRedirect(loginRequest);
  };

  return { profileEdit, logout, redirectLogin, accounts };
};
